import { Tag } from 'antd';
import type { ScheduleConfigurationStatus } from 'services/api/schedule-configuration';
import styles from '../../ui/styles.module.scss';

export const getStatusTag = (status: ScheduleConfigurationStatus) => {
  switch (status) {
    case 'DRAFT':
      return <Tag className={styles.tag}>Черновик</Tag>;
    case 'PUBLISHED':
      return (
        <Tag color="blue" className={styles.tag}>
          Опубликован
        </Tag>
      );
    default:
      return null;
  }
};
